function memoize(fn) {
  const cache = Object.create(null);
  return arg => {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

export { memoize };
